// extracted by mini-css-extract-plugin
export default {"infoBlocks":"LegalInfo_infoBlocks__0cnGI","block":"LegalInfo_block__dO6mO","item":"LegalInfo_item__Y1ivp","title":"LegalInfo_title__8bcOd"};